<button
  [class]="button?.classCss"
  @fadeInOut

  [disabled]="button?.disable"
  (click)="onAction()">
  @if (button?.svgIcon) {
    <mat-icon [svgIcon]="button?.svgIcon"></mat-icon>
  }
  <span>{{ button?.title | translate }}</span>
</button>
